import { type IProduct } from "@/Pages/Product/type";

export enum ECheckoutSource {
  LOCAL = "local",
  INTERNATIONAL = "international",
}

export const CHECKOUT_SOURCE_LABELS = {
  [ECheckoutSource.LOCAL]: "Local",
  [ECheckoutSource.INTERNATIONAL]: "Internacional",
};

type ISourceItem = Cart | ProcessedItems | IProduct;

export const getProductSource = (item: ISourceItem): ECheckoutSource => {
  // Verify if item contain details (Cart)
  if ("details" in item && item.details && "isImported" in item.details) {
    return item.details.isImported === true ? ECheckoutSource.INTERNATIONAL : ECheckoutSource.LOCAL;
  }

  // Verify if item contain isImported (IProduct)
  if ("isImported" in item && item.isImported === true) {
    return ECheckoutSource.INTERNATIONAL;
  }

  // Default
  return ECheckoutSource.LOCAL;
};

// verify if item is local
export const isLocalItem = (item: ISourceItem): boolean => {
  return getProductSource(item) === ECheckoutSource.LOCAL;
};

// verify if item is international
export const isImportedItem = (item: ISourceItem): boolean => {
  return getProductSource(item) === ECheckoutSource.INTERNATIONAL;
};
